import accountIcon from '../../../../assets/images/welcome-pwa/welcome-tips-account.svg';
import downloadIcon from '../../../../assets/images/welcome-pwa/welcome-tips-download.svg';
import mailIcon from '../../../../assets/images/welcome-pwa/welcome-tips-mail.svg';
import appConfig from '../../../config/appConfig';
import * as localizationKeys from '../../../consts/localization/localizationKeys';
import {getLocalizedLanguage} from '../../../services/localization/localizationService';

const WELCOME_PWA_TIPS_DATA = [
    {
        defaultIcon: downloadIcon,
        titleKey: localizationKeys.WELCOME_PWA_TIPS_ITEM_1,
    },
    {
        defaultIcon: mailIcon,
        titleKey: localizationKeys.WELCOME_PWA_TIPS_ITEM_2,
    },
    {
        defaultIcon: accountIcon,
        titleKey: localizationKeys.WELCOME_PWA_TIPS_ITEM_3,
    },
];

const getTipsData = () => {
    const iconsConfig = appConfig.getWelcomePwaTipsIcons();

    if (!iconsConfig?.length) return WELCOME_PWA_TIPS_DATA;

    return iconsConfig.reduce((tipsArray, iconPath, index) => {
        const tipData = WELCOME_PWA_TIPS_DATA[index];

        if (!tipData?.titleKey) return tipsArray;

        const currentTip = {
            ...tipData,
            iconPath: appConfig.getCombinedPathAssetPath(iconPath),
        };

        return [...tipsArray, currentTip];
    }, []);
};

const getMediaData = () => {
    const videoSrc = appConfig.getWelcomePwaVideoSrc();
    const thumbnailSrc = appConfig.getWelcomePwaThumbnailSrc();
    const imageSrc = appConfig.getWelcomePwaImageSrc();
    const imagePath = appConfig.getCombinedPathAssetPath(imageSrc);

    return {videoSrc, thumbnailSrc, imagePath};
};

const getButtonLink = () => {
    const languageCode = getLocalizedLanguage();

    return `${appConfig.getWelcomePwaButtonLink()}?l=${languageCode}`;
};

export default {getButtonLink, getMediaData, getTipsData};
